// Disposition de la scene 3D (fonctions pures, sans three) : parcelles de groupe en grille,
// tours d'environnement sur chaque parcelle. Unites arbitraires de la scene.
import { CATEGORIES_AFFICHAGE } from "./categoriesFlux";
import { jobsDeCategorie } from "./filtresMap";

// Message affiche quand WebGL est indisponible (detection ou creation du renderer en echec).
export const MESSAGE_WEBGL =
  "La vue 3D nécessite WebGL, indisponible ou désactivé dans ce navigateur. " +
  "Activez l'accélération matérielle (ou WebGL) dans les paramètres du navigateur, " +
  "ou utilisez une autre vue.";

export const PAS_TOUR = 1.6; // pas entre deux tours d'une parcelle
export const MARGE_PARCELLE = 1.2;
export const ECART_PARCELLES = 2;
export const HAUTEUR_JOB = 0.22;
export const HAUTEUR_MIN = 0.15;

/*
 * groupes : sortie de agregerGroupes. Retourne { parcelles, largeur, profondeur } ;
 * parcelle = { groupe, c (tours par ligne), w (cote), x, z, tours: [{ env, x, z, etages }] }
 * ou x/z sont relatifs au coin de la scene (a recentrer par -largeur/2, -profondeur/2) et
 * etages = [{ categorie, y, h }] (hauteur = nombre de traitements de la categorie).
 */
export function planifierScene3D(groupes) {
  const liste = Array.isArray(groupes) ? groupes : [];
  const colonnes = Math.max(1, Math.ceil(Math.sqrt(liste.length)));
  let x = 0;
  let z = 0;
  let profondeurLigne = 0;
  let colonne = 0;
  const parcelles = liste.map((g) => {
    const c = Math.max(1, Math.ceil(Math.sqrt(g.envs.length)));
    const w = c * PAS_TOUR + MARGE_PARCELLE;
    if (colonne === colonnes) {
      colonne = 0;
      x = 0;
      z += profondeurLigne + ECART_PARCELLES;
      profondeurLigne = 0;
    }
    const p = { groupe: g, c, w, x, z, tours: [] };
    p.tours = g.envs.map((env, i) => {
      const r = Math.floor(i / c);
      const k = i % c;
      let y = 0;
      const etages = [];
      CATEGORIES_AFFICHAGE.forEach((categorie) => {
        const n = jobsDeCategorie(env, categorie).length;
        if (!n) return;
        const h = Math.max(HAUTEUR_MIN, n * HAUTEUR_JOB);
        etages.push({ categorie, y, h });
        y += h;
      });
      return {
        env,
        x: x + MARGE_PARCELLE / 2 + k * PAS_TOUR + PAS_TOUR / 2,
        z: z + MARGE_PARCELLE / 2 + r * PAS_TOUR + PAS_TOUR / 2,
        etages,
        hauteur: y,
      };
    });
    x += w + ECART_PARCELLES;
    profondeurLigne = Math.max(profondeurLigne, w);
    colonne += 1;
    return p;
  });
  const largeur = parcelles.length ? Math.max(...parcelles.map((p) => p.x + p.w)) : 0;
  const profondeur = parcelles.length ? Math.max(...parcelles.map((p) => p.z + p.w)) : 0;
  return { parcelles, largeur, profondeur };
}
